export enum Jurisdiction {
  ZERTES = 'zertes',
  EIDAS = 'eidas',
  GUEST_SES = 'guest_ses'
}
